export default __webpack_public_path__ + "static/media/icon-sms-code.3c2e1457.svg";